module.exports = __webpack_public_path__ + "img/L1B.efacecd4.jpg";